import React, {useEffect, useState} from "react";
import {firestore} from "../../utils/firebase";
import "../surveyAdherence.css";
import {Col, Container, Jumbotron, Row,Table} from "react-bootstrap";






const EproBaseGap005 = (props) => {
    const {eproKey} = props;
    const [data_retrieved, setData_retrieved] = useState([]);
    const [EproName, setEproName] = useState([]);
    const [arm_data_retrieved, setArm_data_retrieved] = useState([]);
    const [ACTarm, setACTarm] = useState([]);
    const [ACTCount, setACTCount] = useState([]);
    const [ACTMax, setACTMax] = useState([]);
    const [ACTMean, setACTMean] = useState([]);
    const [ACTMin, setACTMin] = useState([]);
    const [ACTp25th, setACTp25th] = useState([]);
    const [ACTp50th, setACTp50th] = useState([]);
	const [ACTp75th, setACTp75th] = useState([]);
	const [STarm, setSTarm] = useState([]);
	const [STCount, setSTCount] = useState([]);
	const [STMax, setSTMax] = useState([]);
	const [STMean, setSTMean] = useState([]);
	const [STMin, setSTMin] = useState([]);
	const [STp25th, setSTp25th] = useState([]);
	const [STp50th, setSTp50th] = useState([]);
	const [STp75th, setSTp75th] = useState([]);
	const [Screenfailedarm, setScreenfailedarm] = useState([]);
	const [ScreenfailedCount, setScreenfailedCount] = useState([]);
	const [ScreenfailedMax, setScreenfailedMax] = useState([]);
	const [ScreenfailedMean, setScreenfailedMean] = useState([]);
	const [ScreenfailedMin, setScreenfailedMin] = useState([]);
	const [Screenfailedp25th, setScreenfailedp25th] = useState([]);
	const [Screenfailedp50th, setScreenfailedp50th] = useState([]);
	const [Screenfailedp75th, setScreenfailedp75th] = useState([]); 

   
    const FeproName = async (eproKey,setter) => { 
        const res = firestore.collection("analytics").doc("A005").collection("baselineEprosA_scoreGaps").doc(eproKey);
        const doc = await res.get();
        const docData=doc.data()
        const resres = docData['name'];
        setter(resres);
        }

  

    const ArmGapData = async (eproKey,arm,met,setter) => { 
        const res = firestore.collection("analytics").doc("A005").collection("baselineEprosA_scoreGaps").doc(eproKey);
        const doc = await res.get();
        const docData=doc.data()
        const resres = docData[arm][met];
        setter(resres);
        }

    useEffect(() => {
        ArmGapData(eproKey,'ACT','p50th',setACTp50th)
		ArmGapData(eproKey,'ACT','Count',setACTCount)
  		ArmGapData(eproKey,'ACT','Max',setACTMax)
  		ArmGapData(eproKey,'ACT','Mean',setACTMean)
  		ArmGapData(eproKey,'ACT','p25th',setACTp25th)
  		ArmGapData(eproKey,'ACT','Min',setACTMin)
  		ArmGapData(eproKey,'ACT','p75th',setACTp75th)
		ArmGapData(eproKey,'ST','Count',setSTCount)
		ArmGapData(eproKey,'ST','Max',setSTMax)
		ArmGapData(eproKey,'ST','Mean',setSTMean)
		ArmGapData(eproKey,'ST','p25th',setSTp25th)
		ArmGapData(eproKey,'ST','Min',setSTMin)
		ArmGapData(eproKey,'ST','p75th',setSTp75th)
		ArmGapData(eproKey,'ST','p50th',setSTp50th)
		ArmGapData(eproKey,'screenfailed','Count',setScreenfailedCount)
		ArmGapData(eproKey,'screenfailed','Max',setScreenfailedMax)
		ArmGapData(eproKey,'screenfailed','Mean',setScreenfailedMean)
		ArmGapData(eproKey,'screenfailed','p25th',setScreenfailedp25th)
		ArmGapData(eproKey,'screenfailed','Min',setScreenfailedMin)
		ArmGapData(eproKey,'screenfailed','p75th',setScreenfailedp75th)
		ArmGapData(eproKey,'screenfailed','p50th',setScreenfailedp50th)
        FeproName(eproKey,setEproName)
  	}, [eproKey]);

return(<>
<div className="TitleC" style={{paddingTop: "0px",paddingBottom: "7px",fontSize: "25px"}}>{EproName}</div>
<table style={{maxWidth:"450px"}} >
<tr >
                <th colSpan={1} style={{  padding: "10px", backgroundColor:"#FF0000",color: "#FFFFFF",fontSize: "20px",textAlign: "center"}} >metric</th>

                <th colSpan={1} style={{  padding: "10px", backgroundColor:"#123A63",color: "#FFFFFF",fontSize: "20px",textAlign: "center"}} >ACT</th>
                <th colSpan={1} style={{  padding: "10px", backgroundColor:"#0F8793",color: "#FFFFFF",fontSize: "20px",textAlign: "center"}} >ST</th>
                <th colSpan={1} style={{  padding: "10px", backgroundColor:"#951B09",color: "#FFFFFF",fontSize: "20px",textAlign: "center"}} >screenfailed</th>
                </tr> 
                
                <tr >
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px",height:"25px", backgroundColor:"#DA36DB",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >participants</td>
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px",height:"25px", backgroundColor:"#2475C7",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ACTCount}</td>
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px",height:"25px", backgroundColor:"#17BECF",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{STCount}</td>
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px",height:"25px", backgroundColor:"#F55C48",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ScreenfailedCount}</td>
                </tr> 
                <tr >
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px",height:"25px", backgroundColor:"#DA36DB",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >mean</td>
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px",height:"25px", backgroundColor:"#2475C7",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ACTMean}</td>
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px",height:"25px", backgroundColor:"#17BECF",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{STMean}</td>
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px",height:"25px", backgroundColor:"#F55C48",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ScreenfailedMean}</td>
                </tr> 
                
                <tr >
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px", backgroundColor:"#DA36DB",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >max</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#2475C7",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ACTMax}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#17BECF",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{STMax}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#F55C48",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ScreenfailedMax}</td>
                </tr> 
               
                <tr >
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px", backgroundColor:"#DA36DB",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >min</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#2475C7",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ACTMin}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#17BECF",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{STMin}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#F55C48",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ScreenfailedMin}</td>
                </tr> 
                  
                <tr >
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px", backgroundColor:"#DA36DB",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >25th</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#2475C7",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ACTp25th}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#17BECF",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{STp25th}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#F55C48",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{Screenfailedp25th}</td>
                </tr>
                
                <tr >
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px", backgroundColor:"#DA36DB",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >50th</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#2475C7",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ACTp50th}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#17BECF",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{STp50th}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#F55C48",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{Screenfailedp50th}</td>
                </tr>
                
                <tr >
                <td colSpan={1} style={{  paddingLeft: "10px",paddingRight: "5px", backgroundColor:"#DA36DB",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >75th</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#2475C7",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{ACTp75th}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#17BECF",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{STp75th}</td>
                <td colSpan={1} style={{ paddingLeft: "10px",paddingRight: "5px",  backgroundColor:"#F55C48",color: "#FFFFFF",fontSize: "18px",textAlign: "right",border: "1px solid white"}} >{Screenfailedp75th}</td>
                </tr>
                       </table> 

    </>);

};
export default EproBaseGap005;